/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { IconShapeCollection } from '@cds/core/icon/interfaces/icon.interfaces';

import { ICONS_STATES } from '../icon-groups/icon-inventory';

export interface IconVariant {
  solid: boolean;
  badge: string;
}

@Pipe({
  name: 'appIconVariants',
})
export class IconVariantsPipe implements PipeTransform {
  transform(iconDetails: IconShapeCollection) {
    return getIconVariants(iconDetails);
  }
}

export function getIconVariants(iconDetails: IconShapeCollection) {
  const iconVariants: IconVariant[] = [];

  if (iconDetails.outline) {
    iconVariants.push({
      solid: false,
      badge: '',
    });
  }

  if (iconDetails.outlineBadged) {
    iconVariants.push(
      ...ICONS_STATES.badged.map(badge => ({
        solid: false,
        badge: badge,
      }))
    );
  }

  if (iconDetails.outlineAlerted) {
    iconVariants.push(
      ...ICONS_STATES.alerted.map(badge => ({
        solid: false,
        badge: badge,
      }))
    );
  }

  if (iconDetails.solid) {
    iconVariants.push({
      solid: true,
      badge: '',
    });
  }

  if (iconDetails.solidBadged) {
    iconVariants.push(
      ...ICONS_STATES.badged.map(badge => ({
        solid: true,
        badge: badge,
      }))
    );
  }

  if (iconDetails.solidAlerted) {
    iconVariants.push(
      ...ICONS_STATES.alerted.map(badge => ({
        solid: true,
        badge: badge,
      }))
    );
  }

  return iconVariants;
}
